import { InvoiceDetailMain } from './components/containers';
import { COURIER_INVOICES_BASE_PATH } from '../constants';
import { Navigate, useParams } from 'react-router-dom';

export const CourierInvoiceView = () => {
  const { id } = useParams<{ id: string }>();
  const invoiceId = Number(id);

  if (!id || Number.isNaN(invoiceId) || invoiceId <= 0) {
    return <Navigate to={COURIER_INVOICES_BASE_PATH} replace />;
  }

  return <InvoiceDetailMain invoiceId={invoiceId} />;
};
